import { axios as axiosEvaluator } from '@campx-org/campx-web-utils'
import Cookies from 'js-cookie'
import { urlTenantKey } from 'components/Providers'
import { generateClientToken } from './client-auth-token'

axiosEvaluator.interceptors.request.use((config) => {
  const evaluatorKey = Cookies.get('campx_evaluator_key')
  if (evaluatorKey) {
    config.headers.set('campx_evaluator_key', evaluatorKey)
  }

  // Evaluator is hosted on a fixed domain (evaluator.campx.in) with tenant in path
  // Always override tenant headers using path-based tenant key
  if (urlTenantKey) {
    config.headers.set('x-tenant-id', urlTenantKey)
  }

  const campxClientId = process.env.REACT_APP_CLIENT_ID
  const campxClientSecret = process.env.REACT_APP_CAMPX_CLIENT_SECRET
  if (campxClientId && campxClientSecret) {
    config.headers.set('x-campx-client', generateClientToken(campxClientId, campxClientSecret))
  }

  return config
})

export default axiosEvaluator
